import {ColumnPropertyLazySelect} from "../../../../types/records-table.types";
import {resources} from "../../../../models/resource/resources";
import {ContactFormFields} from "../types/contacts-modal.types";
import {DeleteConfirmationParams} from "../../../../types/confirmation-modal.types";
import {defaultDeleteConfirmationParams} from "../../../../models/default-delete-confirmation-params";
import {Validators} from "@angular/forms";

export const contactResourceType = resources['blogger-contacts'];

export const contactFormFields: Array<ContactFormFields> = [
  {
    label: 'ФИО',
    fieldName: 'fio',
    type: 'text',
    validators: [ Validators.required ]
  },
  {
    label: 'Телефон',
    fieldName: 'phoneNumber',
    type: 'number'
  },
  {
    label: 'Почта',
    fieldName: 'mail',
    type: 'text'
  },
  {
    label: 'Inst',
    fieldName: 'instagram',
    type: 'text'
  },
  {
    label: 'Youtube',
    fieldName: 'youtube',
    type: 'text'
  },
  {
    label: 'Vkontakte',
    fieldName: 'vk',
    type: 'text'
  },
  {
    label: 'Telegram',
    fieldName: 'telegram',
    type: 'text'
  },
  {
    label: 'Whatsapp',
    fieldName: 'whatsapp',
    type: 'text'
  },
  {
    label: 'Telegram Account',
    fieldName: 'telegramAccountId',
    type: 'select'
  }
]

export const deleteConfirmationParams: DeleteConfirmationParams = {
  ...defaultDeleteConfirmationParams,
  titleText: `Удалить контакт`,
  description: 'Вы действительно хотите удалить контакт?',
  buttonWarmText: 'Удалить',
}

export const unbindConfirmationParams: DeleteConfirmationParams = {
  ...defaultDeleteConfirmationParams,
  titleText: 'Отвязать контакт',
  description: 'Вы действительно хотите отвязать контакт?',
  buttonWarmText: 'Отвязать',
}

export const propertyLazySelectAccountTgIds: ColumnPropertyLazySelect = {
  recourseName: 'BloggerContact',
  providerType: 'TELEGRAM_ACCOUNT_IDS'
}
